export default {
  overLimit: '超过最大下载限制',
  orderNo: '订单号'
}
